import Stack from "@mui/material/Stack";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { Button, Dialog, Divider, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { attrTableStrColumnsObj } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { grey } from "@mui/material/colors";
import { attrGrpAttrAssocObj } from "../data";
import { PimDashboardState } from "context/PimDashboardContext";
import axios from "axios";
import { Reorder } from "framer-motion";
import { DragIndicator } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";

function ArrangeGroupModal({ attrGroupsState, setAttrGroupsState, setModalOpen, modalOpen }) {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr } = PimDashboardState();
	const [attrGroupsStrArr, setAttrGroupsStrArr] = useState();

	useEffect(() => {
		if (attrGroupsWithAttr) {
			setAttrGroupsStrArr(
				Object.values(attrGroupsWithAttr)
					.reduce((acc, row) => {
						if (row.is_main === false) acc.push(row.group_id);
						return acc;
					}, [])
					.sort((a, b) => attrGroupsWithAttr[a].sort_no - attrGroupsWithAttr[b].sort_no),
			);
		}
	}, [attrGroupsWithAttr]);

	const handleModalClose = () => {
		setModalOpen(false);
		setAttrGroupsStrArr();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		try {
			const res = await axios.put("/api/attr_master/reorder_attr_grps", attrGroupsStrArr);
			if (res) {
				let obj = {
					...attrGroupsWithAttr,
					...attrGroupsStrArr?.reduce((acc, row) => {
						acc[row] = { ...attrGroupsWithAttr[row], sort_no: attrGroupsStrArr.indexOf(row) + 1 };
						return acc;
					}, {}),
				};
				setAttrGroupsState({ ...obj });
				setAttrGroupsWithAttr({ ...obj });
				handleModalClose(res);

				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Attribute Reorder Saved",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	const handleAttrGrpReoredr = (valArr) => {
		setAttrGroupsStrArr(valArr);
	};

	if (attrGroupsStrArr && modalOpen)
		return (
			<Dialog onClose={handleModalClose} open={modalOpen} maxWidth="sm" fullWidth>
				<Stack component="form" onSubmit={handleSubmit} p={1} spacing={1} alignItems="center">
					<Box width="100%">
						<Typography variant="h6" pt={0} width={"100%"} textTransform="capitalize">
							Arrange Attribute Groups
						</Typography>

						<Divider sx={{ width: "100%", mt: 1 }} />
					</Box>
					<Reorder.Group
						values={attrGroupsStrArr}
						axis="y"
						onReorder={handleAttrGrpReoredr}
						style={{
							border: `1px solid ${grey[200]}`,
							listStyleType: "none",
							height: "50vh",
							width: "80%",
							padding: 0,
							overflowY: "scroll",
						}}>
						{attrGroupsStrArr?.map((item) => (
							<Reorder.Item key={item} value={item}>
								<ListItem sx={{ border: `1px solid ${grey[200]}`, background: "white" }}>
									<ListItemIcon>
										<DragIndicator />
									</ListItemIcon>
									<ListItemText primary={attrGroupsWithAttr[item].name} />
								</ListItem>
							</Reorder.Item>
						))}
					</Reorder.Group>
					<Box alignSelf="flex-end" display="flex" columnGap={"10px"}>
						<Button variant="outlined" size="small" onClick={handleModalClose}>
							Cancel
						</Button>
						<Button variant="contained" type="submit" size="small">
							Save
						</Button>
					</Box>
				</Stack>
			</Dialog>
		);
	else return <></>;
}

export default ArrangeGroupModal;
